import React from 'react'
import { Field } from 'sb-formx'
import { useCallback, useState, useEffect } from 'sb-hooks'

import CheckboxView, { CheckboxViewProps } from './CheckboxView/CheckboxView'


export type CheckboxProps = CheckboxViewProps & {
  field: Field
  onChange?: (value: boolean) => void
}

const Checkbox: React.FunctionComponent<CheckboxProps> = (props) => {
  const { children, className, field, label, labelProps = {}, dataTestId, onChange } = props

  const isChecked = Boolean(field.value)
  const [ _, setChecked ] = useState(isChecked)

  const handleChange = useCallback((event) => {
    const { checked } = event.target

    field.set(checked)
  }, [ field ])

  useEffect(() => {
    const handleFieldChange = (newValue) => {
      setChecked(newValue)

      if (typeof onChange === 'function') {
        onChange(newValue)
      }
    }

    field.on('change', handleFieldChange)

    return () => {
      field.off('change', handleFieldChange)
    }
  }, [ field, onChange ])

  return (
    <CheckboxView
      className={className}
      label={label}
      labelProps={labelProps}
      value={isChecked}
      onChange={handleChange}
      dataTestId={dataTestId}
    >
      {children}
    </CheckboxView>
  )
}


export default Checkbox
